import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var DoNotHaveRequestedInfoIA = function DoNotHaveRequestedInfoIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.Account.NOT_OPEN ? articlePage(articles.Account.NOT_OPEN.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [DO_NOT_HAVE_INFO_NEEDED(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "ici5fB",
    defaultMessage: [{
      "type": 0,
      "value": "Fournissez des informations pour vérifier votre compte"
    }]
  });
};
var DO_NOT_HAVE_INFO_NEEDED = function DO_NOT_HAVE_INFO_NEEDED(strictLocalize) {
  return strictLocalize({
    id: "fbjw9s",
    defaultMessage: [{
      "type": 0,
      "value": "Vous ne disposez pas encore de toutes les informations nécessaires pour vérifier votre compte ? Ce n'est pas grave. Faites-le nous savoir, et nous mettrons votre commande en attente jusqu'à 30 jours à compter de la date de la commande, le temps que vous obteniez les informations requises."
    }]
  });
};